var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4DPauseS0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190.06 190.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fdfdfd;opacity:0;}.cls-2{fill:#060606;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.66,190c-25,0-50,.05-75,0A19.33,19.33,0,0,1,.12,170.51C-.07,120.2,0,69.9.05,19.59A19.88,19.88,0,0,1,19.69,0Q94.9,0,170.11,0A19.89,19.89,0,0,1,190,19.83q0,75.21-.05,150.42A19.67,19.67,0,0,1,170.12,190Q132.39,190,94.66,190ZM35.06,95.23A60,60,0,1,0,94.92,35,60,60,0,0,0,35.06,95.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.06,95.23A60,60,0,1,1,95.36,155,59.95,59.95,0,0,1,35.06,95.23Zm59.77,46.82A47,47,0,1,0,48,95,47.08,47.08,0,0,0,94.83,142.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75,127.9H82.31V61.3h7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79,127.85h-7.51V61.26h7.51Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4DPauseS0);
export default __webpack_public_path__ + "static/media/4DPause-s0.85526aac2194233dd149b53e4e89bcc0.svg";
export { ForwardRef as ReactComponent };